/* eslint-disable import/prefer-default-export */
export const tabsList = {
  appliedResume: 'Applied Resume',
  matchingResume: 'Matching Resume',
};
